import React, { useMemo, useRef } from "react";
import { buildRowModel, createRowModelCache } from "./engine/rowModel";
import { RowModelContext, useData, useView } from "./plannerContext";

function sameRows(a, b) {
  if (a.rows.length !== b.rows.length || a.totalHeight !== b.totalHeight) return false;
  for (let i = 0; i < a.rows.length; i += 1) {
    if (a.rows[i] !== b.rows[i]) return false;
  }
  return true;
}

/**
 * Builds the rows from the data and from what is expanded, and publishes them. The data changes whenever tiles of
 * time arrive, but the rows only change when an allocation or the structure did, so when a rebuild produces the same
 * rows the previous model is kept and nothing that reads it is rendered again.
 */
export default function RowModelProvider({ children }) {
  const data = useData((state) => state.data);
  const expanded = useView((state) => state.expanded);

  const cacheRef = useRef(null);
  if (!cacheRef.current) cacheRef.current = createRowModelCache();
  const previousRef = useRef(null);

  const model = useMemo(() => {
    const next = buildRowModel(data, expanded, cacheRef.current);
    if (previousRef.current && sameRows(previousRef.current, next)) return previousRef.current;

    previousRef.current = next;
    return next;
  }, [data, expanded]);

  return <RowModelContext.Provider value={model}>{children}</RowModelContext.Provider>;
}
